// extracted by mini-css-extract-plugin
module.exports = {"allWrapper":"user_allWrapper__3Xkh-","body":"user_body__lJF0a","body_mb":"user_body_mb__BD7MB"};